import PropTypes from "prop-types";

import { Wrapper, Root, Player } from "./styles";

const PlayerContainer = ({ inviteTheme, children, vertical, bordered }) => {
  return (
    <Wrapper vertical={vertical}>
      <Root vertical={vertical} bordered={bordered} inviteTheme={inviteTheme}>
        <Player data-testid="commonPlayer-container">{children}</Player>
      </Root>
    </Wrapper>
  );
};

PlayerContainer.propTypes = {
  inviteTheme: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  vertical: PropTypes.bool,
  bordered: PropTypes.bool,
};

export default PlayerContainer;
